export const formatItemBuilding = (
  building?: string,
  floor?: string,
  room?: string,
  separator = ' / ',
) => {
  return building ? [building, floor, room].filter(Boolean).join(separator) : '';
};
